import Homepage from "./component/Home-Page/HomePage";
import Header from "./component/Header/Header";
import { Divider } from "@mui/material";
import { Outlet } from "react-router-dom";
import Footer from "./component/Footer/Footer";
import ButtonChat from "./component/Button/ButtonChat";
import ButtonOnTop from "./component/Button/ButtonOnTop";
import sukienpc from "../src/assets/images/NewEvent/sukienpc.webp";
import sukiendt from "../src/assets/images/NewEvent/sukiendt.webp";
import { useState, useEffect } from "react";
import { FaRegCircleUser } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";
import { FaSchoolFlag } from "react-icons/fa6";
import { FaShoppingBag } from "react-icons/fa";
import { CiBoxList } from "react-icons/ci";
import { Button } from "flowbite-react";
import { IoMdClose } from "react-icons/io";
import btndk from "../src/assets/images/Chat/btndk.webp"; // Adjust path as needed
import { NotificationManager } from "react-notifications";
import axios from "axios";
import bn1 from "../../my-project/src/assets/images/NewEvent/bn1.webp";
import pop from "../../my-project/src/assets/images/Header/Banner-Home/pop.webp";

function App() {
  const [showImage, setShowImage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    center: "",
    position: "",
    service: "",
  });

  // Detect if the device is mobile
  const isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed

  // Show popup when the component mounts
  useEffect(() => {
    setShowImage(true);
  }, []);

  // Handle click outside to close popup
  const handleOverlayClick = () => {
    setShowImage(false);
  };

  // Handle click outside to close modal
  const handleModalOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowModal(false);
    }
  };

  // Prevent clicks on the popup content from closing it, except for image click
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  // Handle image click to open modal
  const handleImageClick = () => {
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const phoneRegex = /^(0[1-9]{1}[0-9]{8,9})$/;
    if (!formData.name) {
      NotificationManager.error("Tên không được để trống!");
      return false;
    }
    if (!formData.email) {
      NotificationManager.error("Email không được để trống!");
      return false;
    }
    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      NotificationManager.error("Số điện thoại phải có 10 hoặc 11 chữ số!");
      return false;
    }
    if (!formData.center) {
      NotificationManager.error("Tên trung tâm không được để trống!");
      return false;
    }
    if (!formData.position) {
      NotificationManager.error("Vui lòng chọn chức vụ!");
      return false;
    }
    if (!formData.service) {
      NotificationManager.error("Vui lòng chọn gói dịch vụ!");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (!isValid) return;

    setIsLoading(true);
    try {
      const rowData = [
        formData.name,
        formData.email,
        formData.phone,
        formData.center,
        formData.position,
        formData.service,
        new Date().toLocaleString(),
        window.location.pathname,
      ];

      const response = await axios.post(
        "https://api-bluerise.bluerise.com.vn/contact-us",
        { values: rowData }
      );

      if (response.status === 200 && response.data) {
        NotificationManager.success("Thông tin đã được gửi thành công!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          center: "",
          position: "",
          service: "",
        });
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error writing to Google Sheets:", error);
      NotificationManager.error(
        "Đã xảy ra lỗi khi gửi dữ liệu lên Google Sheets!" +
        JSON.stringify(error)
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App relative">
      <div className="fixed w-full z-50">
        <Header />
        <Divider />
      </div>
      <div>
        <Outlet />
      </div>
      <div>
        <Footer />
      </div>
      <ButtonOnTop />
      <ButtonChat />


      {/* {showImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]"
          onClick={handleOverlayClick}
        >
          <div
            className="relative flex items-center justify-center"
            onClick={handleContentClick}
          >
            <img
              src={pop}
              alt="Event Image"
              className="max-w-[90vw] max-h-[80vh] rounded-lg cursor-pointer"
              onClick={handleImageClick}
            />
            <button
              onClick={() => setShowImage(false)}
              className="absolute w-5 h-5 md:h-8 md:w-8 top-2 right-2 bg-red-500 text-white flex items-center justify-center hover:bg-red-700 rounded-full"
            >
              X
            </button>
          </div>
        </div>
      )} */}


      {showModal && (
        <div
          className="fixed inset-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center p-4 sm:p-6 z-[70] overflow-y-auto"
          onClick={handleModalOverlayClick}
        >
          <div
            className="p-4 sm:p-6 rounded-lg w-full max-w-[420px] sm:max-w-[480px] md:max-w-[540px] shadow-custom-light flex flex-col gap-4 items-center relative bg-center bg-cover bg-no-repeat min-h-[500px] sm:min-h-[540px]"
            onClick={(e) => e.stopPropagation()}
            style={{ backgroundImage: `url(${btndk})` }}
          >
            <div
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-[#E6ECFA] absolute -top-3 -right-3 sm:-top-4 sm:-right-4 z-10 cursor-pointer"
              onClick={() => setShowModal(false)}
            >
              <IoMdClose className="text-lg sm:text-xl" />
            </div>

            <div className="text-center">
              <p className="text-[20px] sm:text-[24px] font-semibold text-white mt-10">
                ĐĂNG KÝ NHẬN TƯ VẤN
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              className="w-full mt-2 sm:mt-4 flex-1 flex flex-col justify-between"
            >
              <div className="w-full space-y-2 sm:space-y-4">
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full md:mt-16 mt-20">
                  <FaRegCircleUser className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Nhập họ và tên của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full">
                  <CiMail className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Nhập email của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full">
                  <FiPhone className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Nhập số điện thoại của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full">
                  <FaSchoolFlag className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="center"
                    value={formData.center}
                    onChange={handleChange}
                    placeholder="Nhập tên trung tâm bạn đang làm việc"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full text-gray-500">
                  <FaShoppingBag className="text-gray-500 mr-2 text-lg" />
                  <select
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    className="flex-1 bg-transparent outline-none border-none placeholder-gray-400 text-sm sm:text-base"
                  >
                    <option value="">Chức vụ của bạn</option>
                    <option value="Giám đốc Trung Tâm">
                      Giám đốc Trung Tâm
                    </option>
                    <option value="Quản lý Trung Tâm">Quản lý Trung Tâm</option>
                    <option value="Giáo viên">Giáo viên</option>
                    <option value="Gia sư">Gia sư</option>
                    <option value="Học sinh">Học sinh</option>
                    <option value="Trợ giảng">Trợ giảng</option>
                  </select>
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full text-gray-500">
                  <CiBoxList className="text-gray-500 mr-2 text-lg" />
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="flex-1 bg-transparent outline-none border-none placeholder-gray-400 text-sm sm:text-base"
                  >
                    <option value="">Chọn gói dịch vụ cần tư vấn</option>
                    <option value="Basic">Basic</option>
                    <option value="Premium">Premium</option>
                    <option value="Unlimited">Unlimited</option>
                  </select>
                </div>
              </div>
              <Button
                type="submit"
                className="w-full py-2 sm:py-3 bg-[#053CC8] text-white rounded-[30px] text-sm sm:text-base mt-4"
                disabled={isLoading}
              >
                {isLoading ? "Đang gửi..." : "Đăng ký"}
              </Button>
            </form>
          </div>
        </div>
      )}

      <style>{`
        @keyframes throb {
          0% { transform: scale(1); }
          50% { transform: scale(1.15); }
          100% { transform: scale(1); }
        }
        
        @keyframes ping {
          0% { transform: scale(1); opacity: 1; }
          75% { transform: scale(1.5); opacity: 0; }
          100% { transform: scale(1); opacity: 0; }
        }
      `}</style>
    </div>
  );
}

export default App;